import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import AgentCWriter from './pages/AgentCWriter/AgentCWriter';

// Placeholder components for other routes
const History = () => <div>History Page</div>;
const TrainModels = () => <div>Train Models Page</div>;
const FeatureRequests = () => <div>Feature Requests Page</div>;
const Settings = () => <div>Settings Page</div>;

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<AgentCWriter />} />
          <Route path="/history" element={<History />} />
          <Route path="/train" element={<TrainModels />} />
          <Route path="/features" element={<FeatureRequests />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
